<template>
<div id="admin-add">
  <bo-add-user title="Nouvel utilisateur"
               subtitle="Programme National"
               action="add"
               :groups="['user', 'ghost']"
               userCss="col-xs-10 col-sm-8 col-md-4"
               @end-edit-user="goToList($event)"
               :routePrefix="routePrefix"
               storePrefix="user"></bo-add-user>
</div>
</template>

<script>
import boAddUser from '@/components/boadduser'

export default {
  name: 'mission-add',
  data () {
    return {
      routePrefix: 'mission'
    }
  },
  components: {
    'bo-add-user': boAddUser
  },
  methods: {
    goToList: function (event) {
      this.$router.push(`/${this.routePrefix}/list`)
    }
  }
}
</script>

<style scoped lang="less">

</style>
